import React, { useEffect } from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { tokens } from "../../theme";
import { useAppDispatch } from "../../redux/slice/redux-hooks";
import { useNavigation } from "../../hooks/useNavigation";
import OptionsPopup, { OptionPopupObjectProps } from "../common/OptionsPopup";
import { setSingleAlertObj, useCommonReducer } from "../../redux/slice/commonSlice";
import { acknowledgeNotification, deleteNotification, deleteNotificationRequest, notificationAttachmentDTO, NotificationListDTO } from "../../redux/slice/inbox/createNotificationSlice";
import { fetchOrderDocumentsByIds, SearchOrder } from "../../redux/slice/order/OrderSlice";
import { SearchIVRListRequest } from "../../redux/slice/ivr/createIVRSlice";
import { SearchPracticeRequest } from "../../redux/slice/practiceSlice";
import { SearchInvoiceInfo } from "../../redux/slice/invoice/InvoiceSlice";
import AssignPopup from "../operation/inbox/AssignPopup";
import PDFViewer from "../common/pdf/PDFViewer";
import CustomIconButton from "../common/CustomIconButton";
import { PreviewOutlined } from "@mui/icons-material";


interface DashboardNotificationItemProps {
    notification: NotificationListDTO;
    time: string;
    formattedTime?: string;
    formattedDate?: string;
    acknowledged: boolean;
    isAssignable: boolean;
    index: number;
    total: number;
    onAcknowledge: () => void;
    showGoButton?: boolean;
    createdDate?: string;
    createdTime?: string;
    ackedByUserName?: string;
    refreshPage: () => void;
}

const DashboardNotificationItem: React.FC<DashboardNotificationItemProps> = ({
    notification,
    time,
    formattedTime,
    formattedDate,
    acknowledged,
    isAssignable,
    index,
    total,
    onAcknowledge,
    showGoButton,
    createdDate,
    createdTime,
    ackedByUserName,
    refreshPage
}) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dispatch = useAppDispatch();
    const { navigate } = useNavigation();
    const isSm = useMediaQuery(theme.breakpoints.down("sm"));
    const [showAssignPopup, setShowAssignPopup] = React.useState<boolean>(false);
    const [pdfContent, setPDFContent] = React.useState<string>("");
    const [showPDF, setShowPDF] = React.useState<{ isShow: boolean, title: string, fileName: string }>({ isShow: false, title: "", fileName: "" });
    const [showOptionPopup, setShowOptionsPopup] = React.useState<OptionPopupObjectProps>({ message: '', show: false });
    const { documentDataFromCommonApi } = useCommonReducer();
    const [popupMode, setPopupMode] = React.useState<string>('');

    const isLast = index === total - 1;

    const ENTITY_ITEMS_PER_PAGE = 20;

    useEffect(() => {

    }, [])
    const handleAck = async () => {
        try {
            const notificationData = {
                notificationId: notification.notificationId,
                comment: ""
            }
            const response = await dispatch(acknowledgeNotification(notificationData)).unwrap();
            if (onAcknowledge) onAcknowledge();
            return response;
        } catch (err) {
            return [];
        }
    };

    const handleAssign = async () => {
        setShowAssignPopup(true)
    }

    const handleNavigation = () => {
        if (notification.entity === "ORDER") {
            if (notification.entityId) {
                let searchCriteriaOrder: SearchOrder = {
                    orderIds: [notification.entityId],
                    practiceIds: [],
                    manufacturerIds: [],
                    patientFirstName: "",
                    patientLastName: "",
                    productIds: [],
                    providerName: "",
                    orderNumber: "",
                    invoiceNumber: "",
                    serialNumber: "",
                    fromDate: "",
                    toDate: "",
                    status: [],
                    invoiceStatus: [],
                    currentPage: 1,
                    itemsPerPage: ENTITY_ITEMS_PER_PAGE,
                    downloadState: false,
                    fromServiceDate: '',
                    toServiceDate: ''
                };
                navigate("/order_list", { state: { orderListSearchCriteria: searchCriteriaOrder } });
            }
        } else if (notification.entity === "IVR") {
            let searchCriteriaIvr: SearchIVRListRequest = {
                ivrIds: [notification.entityId],
                productId: [],
                practiceId: [],
                productCategory: [],
                patientFirstName: "",
                patientLastName: "",
                verificationStatus: [],
                ivrNumber: '',
                fromDate: "",
                toDate: "",
                currentPage: 1,
                itemsPerPage: ENTITY_ITEMS_PER_PAGE
            };
            navigate("/ivr_list", { state: { ivrListSearchCriteria: searchCriteriaIvr } })
        } else if (notification.entity === "PRACTICE") {
            let searchCriteria: SearchPracticeRequest = {
                practiceId: notification.entityId,
                contactFirstName: '',
                contactLastName: '',
                contactEmail: '',
                contactPhone: '',
                approvalStatus: '',
                agencyId: null,
                userId: null,
                currentPage: 1,
                itemsPerPage: ENTITY_ITEMS_PER_PAGE
            };
            navigate("/practice_list", { state: { practiceListSearchCriteria: searchCriteria } })
        } else if (notification.entity === "INVOICE") {
            let searchCriteriaInvoice: SearchInvoiceInfo = {
                invoiceId: notification.entityId,
                mfgInvoiceNumber: "",
                currentPage: 1,
                fromDate: '',
                toDate: '',
                itemsPerPage: ENTITY_ITEMS_PER_PAGE,
                invoiceStatus: [],
                agencyIds: [],
                practiceIds: [],
                mfgIds: [],
                isDownload: false,
                excludePurchaseAndBill: false,
                patientIds: [],
            };
            navigate("/invoice_list", { state: { invoiceListSearchCriteria: searchCriteriaInvoice } })
        } else if (notification.entity === "PAYMENT") {
            let searchCriteriaPayment = {
                paymentId: notification.entityId,
                currentPage: 1,
                itemsPerPage: ENTITY_ITEMS_PER_PAGE,
            }
            return navigate("/payment_list", { state: { paymentListSearchCriteria: searchCriteriaPayment } })
        } else if (notification.entity === "PRACTICE_PRODUCT") {
            let agreementListSearchCriteria = {
                agreementIds: [notification.entityId],
                productIds: [],
                manufacturerIds: [], 
                practiceIds: [],
                agreementStatus: [],
                agreementValidity: [],
                currentPage: 1,
                itemsPerPage: ENTITY_ITEMS_PER_PAGE
            }
            return navigate("/practice_product_agreement", { state: { agreementListSearchCriteria: agreementListSearchCriteria } })
        }
    }

    const stripHtml = (html: string) => {
        const div = document.createElement("div");
        div.innerHTML = html;
        return div.textContent || div.innerText || "";
    };

    const handleActionPreview = async (attachment: notificationAttachmentDTO, type: string) => {
        const documentId = attachment.documentId;
        if (documentId) {
            const actionResult = await dispatch(fetchOrderDocumentsByIds([documentId]));
            const documentData = actionResult.payload;

            if (documentData?.content) {
                setPDFContent(documentData.content);
                setShowPDF({
                    isShow: true,
                    title: documentData.patientName,
                    fileName: documentData.documentName,
                });
            } else {
                dispatch(setSingleAlertObj({
                    message: "Requested Document has not found under server location!",
                    alertType: "info",
                }));
            }
        }
    };

    const handleDeleteAction = async () => {
        const data = {
            notificationId: notification.notificationId,
        }

        {
            setShowOptionsPopup({
                message: "Do you really want to delete this notification?",
                show: true,
                variant: "confirm",
                buttons: [{ name: "Confirm", color: 'primary', onClick: () => deleteNotificationById(data) }, { name: "Cancel", color: 'secondary', onClick: cancelOptionPopup }]
            })
        }

    }

    const cancelOptionPopup = () => {
        setShowOptionsPopup({ message: "", show: false });
    }

    const deleteNotificationById = async (data: deleteNotificationRequest) => {
        cancelOptionPopup();
        const response = await dispatch(deleteNotification(data)).unwrap();
        refreshPage()
    }

    const handleViewClick = () => {
        setPopupMode('view');
        setShowAssignPopup(true);
    };

    const isDark = theme.palette.mode === "dark";
    const cardBg = isDark ? "#191c24" : "#ffffff";
    const borderColor = isDark ? "rgba(255,255,255,0.07)" : "#e5e9ed";
    const rowBorder = isDark ? "rgba(255,255,255,0.06)" : "#f1f5f9";

    return (
        <>
            {showOptionPopup.show &&
                <OptionsPopup
                    open={showOptionPopup.show}
                    onClose={() => setShowOptionsPopup({ message: "", show: false })}
                    variant={showOptionPopup.variant}
                    message={<>{showOptionPopup.message}</>}
                    buttons={showOptionPopup.buttons}
                    title={showOptionPopup.title}
                    obj={showOptionPopup.obj}
                />
            }
            {showPDF.isShow &&
                <PDFViewer
                    isOpen={showPDF.isShow}
                    onClose={() => { setShowPDF({ isShow: false, title: "", fileName: "" }) }}
                    title={showPDF.title}
                    fileName={showPDF.fileName}
                    base64String={documentDataFromCommonApi?.content ? documentDataFromCommonApi?.content : pdfContent}
                />
            }
            {showAssignPopup &&
                <AssignPopup
                    mode={popupMode}
                    canAssign={isAssignable}
                    isAcknowledged={acknowledged}
                    attachments={notification.notificationAttachment ? notification.notificationAttachment : []}
                    open={showAssignPopup}
                    onClose={() => { setShowAssignPopup(false) }}
                    onSubmitAssign={(data) => onAcknowledge()}
                    notification={{
                        notificationId: notification.notificationId,
                        subject: notification.notificationSub ? notification.notificationSub : '',
                        message: stripHtml(notification.notificationMsg ? notification.notificationMsg : ''),
                        category: notification.senderId != null ? 'user' : 'system',
                        time: notification.auditTimeStamp ? notification.auditTimeStamp : ''
                    }}
                />
            }

            <Box
                key={notification.notificationId}
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    px: 3,
                    py: 1.8,
                    borderTop: `1px solid ${rowBorder}`,
                }}
            >
                <Box
                    sx={{
                        width: 10,
                        height: 10,
                        borderRadius: "50%",
                        backgroundColor: "#14b8a6",
                        flexShrink: 0,
                    }}
                />
                <Box flex={1} minWidth={0}>
                    <Typography
                        sx={{
                            fontSize: "0.92rem",
                            fontWeight: 700,
                            color: isDark ? "#e5e9ed" : "#1e293b",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                        }}
                    >
                        {notification.notificationSub}
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: "0.8rem",
                            color: isDark ? "#64748b" : "#94a3b8",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            mt: 0.3,
                        }}
                    >
                        {stripHtml(notification.notificationMsg ? notification.notificationMsg : '')}
                    </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexShrink: 0 }}>
                    {notification.notificationAttachment && notification.notificationAttachment.length > 0 &&
                        notification.notificationAttachment.map((attachment, index) => (
                            <CustomIconButton
                                key={index}
                                color="info"
                                size="small"
                                variant="outlined"
                                onClick={() => handleActionPreview(attachment, "document")}
                                tooltipMessage={`${attachment.documentName}`}
                                tooltipPlacement="bottom"
                                sx={{ ml: index > 0 ? 1 : 0 }}
                            >
                                <PreviewOutlined />
                            </CustomIconButton>
                        ))}
                    {!acknowledged && <Box
                        onClick={handleAck}
                        sx={{
                            px: 2,
                            py: 0.7,
                            borderRadius: 1.5,
                            fontSize: "0.78rem",
                            fontWeight: 600,
                            cursor: "pointer",
                            userSelect: "none",
                            border: `1px solid ${isDark ? "rgba(255,255,255,0.18)" : "rgba(0,0,0,0.18)"}`,
                            color: isDark ? "#cbd5e1" : "#475569",
                            backgroundColor: "transparent",
                            transition: "all 0.18s ease",
                            "&:hover": { borderColor: "#14b8a6", color: "#14b8a6" },
                        }}
                    >
                        ACKNOWLEDGE
                    </Box>}
                    {
                        isAssignable &&
                        <Box
                            onClick={handleAssign}
                            sx={{
                                px: 2,
                                py: 0.7,
                                borderRadius: 1.5,
                                fontSize: "0.78rem",
                                fontWeight: 600,
                                cursor: "pointer",
                                userSelect: "none",
                                border: `1px solid ${isDark ? "rgba(255,255,255,0.18)" : "rgba(0,0,0,0.18)"}`,
                                color: isDark ? "#cbd5e1" : "#475569",
                                backgroundColor: "transparent",
                                transition: "all 0.18s ease",
                                "&:hover": { borderColor: "#14b8a6", color: "#14b8a6" },
                            }}
                        >
                            ASSIGN
                        </Box>
                    }
                    <Box
                        onClick={handleViewClick}
                        sx={{
                            px: 2,
                            py: 0.7,
                            borderRadius: 1.5,
                            fontSize: "0.78rem",
                            fontWeight: 600,
                            cursor: "pointer",
                            userSelect: "none",
                            border: `1px solid ${isDark ? "rgba(255,255,255,0.18)" : "rgba(0,0,0,0.18)"}`,
                            color: isDark ? "#cbd5e1" : "#475569",
                            backgroundColor: "transparent",
                            transition: "all 0.18s ease",
                            "&:hover": { borderColor: "#14b8a6", color: "#14b8a6" },
                        }}
                    >
                        VIEW
                    </Box>
                    {showGoButton &&
                        <Box
                            onClick={handleNavigation}
                            sx={{
                                px: 2,
                                py: 0.7,
                                borderRadius: 1.5,
                                fontSize: "0.78rem",
                                fontWeight: 600,
                                cursor: "pointer",
                                userSelect: "none",
                                border: `1px solid ${isDark ? "rgba(255,255,255,0.18)" : "rgba(0,0,0,0.18)"}`,
                                color: isDark ? "#cbd5e1" : "#475569",
                                backgroundColor: "transparent",
                                transition: "all 0.18s ease",
                                "&:hover": { borderColor: "#14b8a6", color: "#14b8a6" },
                            }}
                        >
                            GO
                        </Box>
                    }
                    {acknowledged && <Box
                        onClick={handleDeleteAction}
                        sx={{
                            px: 2,
                            py: 0.7,
                            borderRadius: 1.5,
                            fontSize: "0.78rem",
                            fontWeight: 600,
                            cursor: "pointer",
                            userSelect: "none",
                            border: "1px solid rgba(220,53,69,0.6)",
                            color: "#dc3545",
                            backgroundColor: "transparent",
                            transition: "all 0.18s ease",
                            "&:hover": {
                                backgroundColor: "rgba(220,53,69,0.08)",
                                borderColor: "#dc3545",
                            },
                        }}
                    >
                        DELETE
                    </Box>}
                    <Typography
                        sx={{
                            fontSize: "0.8rem",
                            color: isDark ? "#64748b" : "#94a3b8",
                            minWidth: 58,
                            textAlign: "right",
                        }}
                    >
                        {formattedTime}
                    </Typography>
                </Box>
            </Box>
        </>
    );
};

export default DashboardNotificationItem;
